// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#activity_panel ::v-deep .item-icon{filter:var(--background-invert-if-dark)}", "",{"version":3,"sources":["webpack://./src/views/Dashboard.vue"],"names":[],"mappings":"AAEC,oCACC,uCAAA","sourcesContent":["\n#activity_panel {\n\t::v-deep .item-icon {\n\t\tfilter: var(--background-invert-if-dark);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
